import { NON_MECHANICAL_BASE } from './_shared'

/** Perfil ELÉCTRICO (electrical_installation). No-mecánico + screenshot propio. */
export default {
  ...NON_MECHANICAL_BASE,
  design: {
    ...NON_MECHANICAL_BASE.design,
    screenshotName: 'electrical.png',
    codePrefix:     'electrical',
    layerIcon:      'bolt',          // icono de las capas del pictograma
  },
}
